let ids = ["phone", "altPhone", "lastName", "firstName", "email", "password",
 "tech", "hdyhau", "manufacture", "item", "model", "charger", "problem",
 "prices", "pricingNotes", "damage", "woNum", "date"];

let values = [];
let date = new Date();
let qs = location.search;

console.log("qs: " + qs); //will be used to set store location


function getValues(){
  values = [];
  ids.forEach((val)=>{
    values.push($("#" + val).val());
  });

let arr = {
  "name": "Rob",
  "age" : "33",
  "sex" : "male"
};
let data = "data=" + JSON.stringify(values);
//console.log(data);

$.getJSON({
  url:"http://localhost:80/scripts/database.php?&method=saveData&jsoncallback=?",

  data: data,

  dataType: "jsonp",

  success: function(result){
    console.log( result);

  }


});

}

function url(array){
  let str = '';
  array.forEach((val, index)=>{
    str += "&var" + index + "=" + val;
  });
  console.log(str);
  return str;
}
function formatPhone(id){
  let str = $("#" + id).val();
  $("#" + id).val(str.substring(0, 3) +
  "-" + str.substring(3, 6) +
  "-" + str.substring(6, 10));
}

function getDate(){

  var date = new Date();
  $("#date").val(date.getMonth() + 1 + "/" +
  date.getDate() + "/" +
  date.getFullYear());
}
function keyup(){
  $("phone").keyup(function(){
    console.log("key");
  });
}

$(document).ready(function(){

  $("#phone").keyup(function(){

    console.log($("#phone").val());
    $("#lastName").attr("placeholder", "Type a Location");
  });
});


$('textarea').bind("enterKey",function(e){
   //do stuff here
});
$('#phone').keyup(function(e){
    if(e.keyCode == 13)
    {
      // console.log("enter");
      // $("#altPhone").focus();
      //   $(this).trigger("enterKey");

      findCustomer($("#phone").val());

    }
});

function findCustomer(phone){
console.log("find str: ", phone);
  let data = "data=" + JSON.stringify(phone);
  $.getJSON({
    url:"http://localhost:80/scripts/database.php?&method=loadData&jsoncallback=?",

    data: data,

    dataType: "jsonp",

    success: function(result){
      console.log( result);

    }


  });
}
